import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderCureAnxiety from "../../../../src/content/cureforanxiety-2/donationHeader";
import "../../../../src/content/cureforanxiety-2/cure-for-anxiety.scss";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderCureAnxiety,
  React
};